import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { API } from "../App";

const POLL_MS = 2500;

export const GenerateReportFromTranscript = ({ reportId, transcript, hasFields, onGenerated, size = "sm", variant = "default", className = "" }) => {
  const [busy, setBusy] = useState(false);
  const [elapsed, setElapsed] = useState(0);
  const timer = useRef(null);
  useEffect(() => () => clearInterval(timer.current), []);

  const ready = (transcript || "").trim().length >= 50;

  const run = async () => {
    if (hasFields && !window.confirm("Le compte rendu contient déjà des champs remplis : les remplacer par une nouvelle génération à partir de la transcription ?")) return;
    setBusy(true); setElapsed(0);
    timer.current = setInterval(() => setElapsed((e) => e + 1), 1000);
    try {
      const start = await axios.post(`${API}/session-reports/${reportId}/generate-fields`, { text: transcript || null }, { withCredentials: true });
      const genId = start.data.generation_id;
      for (;;) {
        await new Promise((r) => setTimeout(r, POLL_MS));
        const st = await axios.get(`${API}/session-reports/generation/${genId}`, { withCredentials: true });
        if (st.data.status === "completed") {
          const filled = Object.values(st.data.fields || {}).filter(Boolean).length;
          toast.success(`Compte rendu généré : ${filled} champ(s) rempli(s)${st.data.route?.label ? ` · ${st.data.route.label}` : ""}`);
          onGenerated?.(st.data.fields || {}, st.data.suggested_exercises || []);
          break;
        }
        if (st.data.status === "error") throw new Error(st.data.error || "Erreur de génération");
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message || "Erreur de génération");
    } finally {
      clearInterval(timer.current); setBusy(false);
    }
  };

  return (
    <Button size={size} variant={variant} onClick={run} disabled={busy || !ready} className={`gap-1.5 ${className}`}
      title={ready ? "Générer le compte rendu structuré à partir de la transcription" : "Ajoutez d'abord une transcription (50 caractères minimum)"}
      data-testid="generate-report-from-transcript-btn">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
      {busy ? `Génération du CR… ${elapsed}s` : "Générer le CR à partir de la transcription"}
    </Button>
  );
};
